import debug from 'debug';

export default {
    objects: {
        updated: debug('canvas:objects:events:updated'),
        render: debug('app:objects:updateCanvas'),
        saveState: debug('app:objects:save')
    },
    api: {
        events: {
            updateCanvasObjectFailed: debug('app:api:event:updateCanvasObjectFailed'),
            createCanvasObjectFailed: debug('app:api:event:createCanvasObjectFailed'),
            createCanvasObjectSuccessfull: debug('app:api:event:createCanvasObjectSuccessfull'),
            updateCanvasObjectSuccessfull: debug('app:api:event:updateCanvasObjectSuccessfull'),
            uploadImageSuccessfull: debug('app:api:event:uploadImageSuccessfull'),
            uploadImageFailed: debug('app:api:event:uploadImageFailed'),
            productConfigurationViewUpdatedSuccessfull: debug('app:api:event:productConfigurationViewUpdatedSuccessfull'),
            productConfigurationViewUpdatedFailed: debug('app:api:event:productConfigurationViewUpdatedFailed'),
            productConfigurationViewCreatedSuccessfull: debug('app:api:event:productConfigurationViewCreatedSuccessfull'),
            productConfigurationViewCreationFailed: debug('app:api:event:productConfigurationViewCreationFailed'),
        }
    },
    views: {
        event: {
            chanceActiveTab: debug('app:views:event:chanceActiveTab')
        }
    }
};